import { render, staticRenderFns } from "./Desk.vue?vue&type=template&id=2b77e65f&scoped=true"
import script from "./Desk.vue?vue&type=script&lang=js"
export * from "./Desk.vue?vue&type=script&lang=js"
import style0 from "./Desk.vue?vue&type=style&index=0&id=2b77e65f&prod&scoped=true&lang=css"
import style1 from "./Desk.vue?vue&type=style&index=1&id=2b77e65f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b77e65f",
  null
  
)

export default component.exports